/**
 * Web Style Import
 *
 */

import './dnb-form-label.scss'
